if (!customElements.get('media-gallery')) {
customElements.define(
'media-gallery',
class MediaGallery extends HTMLElement {
constructor() {
super();
this.elements = {
liveRegion: this.querySelector('[id^="GalleryStatus"]'),
viewer: this.querySelector('[id^="GalleryViewer"]'),
thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
};
this.mql = window.matchMedia('(min-width: 750px)');
if (!this.elements.thumbnails) return;

this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
mediaToSwitch
.querySelector('button')
.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
});
if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();

this.initMobileGestures();
}

initMobileGestures() {
const viewer = this.elements.viewer;
if (!viewer) return;

let holdTimer = null;
let holdFired = false;
let startX = 0, startY = 0;

const getSlides = () => Array.from(viewer.querySelectorAll('li[data-media-id]'));
const getActiveIndex = () => getSlides().findIndex((el) => el.classList.contains('is-active'));
const goNext = () => {
const slides = getSlides();
const i = getActiveIndex();
this.setActiveMedia(slides[i < slides.length - 1 ? i + 1 : 0].dataset.mediaId, false);
};
const goPrev = () => {
const slides = getSlides();
const i = getActiveIndex();
this.setActiveMedia(slides[i > 0 ? i - 1 : slides.length - 1].dataset.mediaId, false);
};

viewer.addEventListener('touchstart', (e) => {
holdFired = false;
startX = e.touches[0].clientX;
startY = e.touches[0].clientY;
holdTimer = setTimeout(() => {
holdFired = true;
goNext();
}, 100);
}, { passive: true });

viewer.addEventListener('touchmove', (e) => {
const dx = Math.abs(e.touches[0].clientX - startX);
const dy = Math.abs(e.touches[0].clientY - startY);
if (dy > 80 || dx > 60) {
clearTimeout(holdTimer);
holdTimer = null;
}
}, { passive: true });

viewer.addEventListener('touchend', (e) => {
clearTimeout(holdTimer);
holdTimer = null;
if (holdFired) return;
const dx = (e.changedTouches[0]?.clientX ?? startX) - startX;
const dy = (e.changedTouches[0]?.clientY ?? startY) - startY;
if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
dx < 0 ? goNext() : goPrev();
}
}, { passive: true });

viewer.addEventListener('click', (e) => {
if (holdFired) {
e.stopImmediatePropagation();
e.preventDefault();
holdFired = false;
}
}, true);
}

onSlideChanged(event) {
const thumbnail = this.elements.thumbnails.querySelector(
`[data-target="${event.detail.currentElement.dataset.mediaId}"]`
);
this.setActiveThumbnail(thumbnail);
}

setActiveMedia(mediaId, prepend) {
const activeMedia =
this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
this.elements.viewer.querySelector('[data-media-id]');
if (!activeMedia) return;
this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
element.classList.remove('is-active');
});
activeMedia?.classList?.add('is-active');

if (prepend) {
activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);
if (this.elements.thumbnails) {
const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
}
if (this.elements.viewer.slider) this.elements.viewer.resetPages();
}

this.preventStickyHeader();
window.setTimeout(() => {
if (!this.mql.matches || this.elements.thumbnails) {
activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
}
const activeMediaRect = activeMedia.getBoundingClientRect();
if (activeMediaRect.top > -0.5) return;
window.scrollTo({ top: activeMediaRect.top + window.scrollY, behavior: 'smooth' });
});
this.playActiveMedia(activeMedia);

if (!this.elements.thumbnails) return;
const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
this.setActiveThumbnail(activeThumbnail);
this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
}

setActiveThumbnail(thumbnail) {
if (!this.elements.thumbnails || !thumbnail) return;
this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
thumbnail.querySelector('button').setAttribute('aria-current', true);
if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
}

announceLiveRegion(activeItem, position) {
const image = activeItem.querySelector('.product__modal-opener--image img');
if (!image) return;
image.onload = () => {
this.elements.liveRegion.setAttribute('aria-hidden', false);
this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
setTimeout(() => { this.elements.liveRegion.setAttribute('aria-hidden', true); }, 2000);
};
image.src = image.src;
}

playActiveMedia(activeItem) {
window.pauseAllMedia();
const deferredMedia = activeItem.querySelector('.deferred-media');
if (deferredMedia) deferredMedia.loadContent(false);
}

preventStickyHeader() {
this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
if (!this.stickyHeader) return;
this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
}

removeListSemantic() {
if (!this.elements.viewer.slider) return;
this.elements.viewer.slider.setAttribute('role', 'presentation');
this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
}
}
);
}

function attachMobileGestures(gallery) {
if (gallery._gesturesAttached) return;
gallery._gesturesAttached = true;

const viewer = gallery.querySelector('[id^="GalleryViewer"]');
if (!viewer) return;

let holdTimer = null;
let holdFired = false;
let startX = 0, startY = 0;

const getSlides = () => Array.from(viewer.querySelectorAll('li[data-media-id]'));
const getActiveIndex = () => getSlides().findIndex((el) => el.classList.contains('is-active'));
const goNext = () => {
const slides = getSlides();
const i = getActiveIndex();
const btn = slides[i < slides.length - 1 ? i + 1 : 0].querySelector('button[data-media-id]');
if (btn) btn.click();
};
const goPrev = () => {
const slides = getSlides();
const i = getActiveIndex();
const btn = slides[i > 0 ? i - 1 : slides.length - 1].querySelector('button[data-media-id]');
if (btn) btn.click();
};

viewer.addEventListener('touchstart', (e) => {
holdFired = false;
startX = e.touches[0].clientX;
startY = e.touches[0].clientY;
holdTimer = setTimeout(() => {
holdFired = true;
goNext();
}, 100);
}, { passive: true });

viewer.addEventListener('touchmove', (e) => {
const dx = Math.abs(e.touches[0].clientX - startX);
const dy = Math.abs(e.touches[0].clientY - startY);
if (dy > 80 || dx > 60) {
clearTimeout(holdTimer);
holdTimer = null;
}
}, { passive: true });

viewer.addEventListener('touchend', (e) => {
clearTimeout(holdTimer);
holdTimer = null;
if (holdFired) return;
const dx = (e.changedTouches[0]?.clientX ?? startX) - startX;
const dy = (e.changedTouches[0]?.clientY ?? startY) - startY;
if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
dx < 0 ? goNext() : goPrev();
}
}, { passive: true });

viewer.addEventListener('click', (e) => {
if (holdFired) {
e.stopImmediatePropagation();
e.preventDefault();
holdFired = false;
}
}, true);
}

document.querySelectorAll('media-gallery').forEach(attachMobileGestures);
new MutationObserver((mutations) => {
mutations.forEach((m) => m.addedNodes.forEach((node) => {
if (node.nodeType !== 1) return;
if (node.tagName === 'MEDIA-GALLERY') attachMobileGestures(node);
node.querySelectorAll?.('media-gallery').forEach(attachMobileGestures);
}));
}).observe(document.body, { childList: true, subtree: true });
